module.exports = __webpack_public_path__ + "5b66926ff07c24682316b5c3654c99a5.png";